<template>
  <div>
    <p class="tw:text-gray-700 tw:pb-2 tw:text-xs required" v-html="$t('required_information')" />
    <p class="tw:font-bold tw:text-xl tw:mb-5" v-html="$t('business_studio_plus_cancellation_question')" />

    <BaseSelect
      id="select-rc-pause-reason"
      :placeholder="$t('rc_pause_flow_menu_prompt')"
      required
      groupedOptions
      size="big"
      :options="reasons"
      display-text-key="label"
      @onChange="e => selectReason(e)"
      labelRequiresTranslation
      :value="selectedReason"
      data-testid="cancellation-reason-select"
    />

    <div v-if="showHint && selectedReasonObject" data-testid="hints-feedback-container">
      <HintsCard
        v-if="selectedReasonObject.id !== 'property_closed'"
        :id="selectedReasonObject.id"
        :hasOffer="hasActiveOffer"
        :hasCompetitors="hasCompetitors"
        :currentAccommodationId="currentAccommodationId"
        :currentOrganisationId="selectedOrganisation?.id"
        data-testid="cancellation-hints-card"
      />
      <FeedbackField
        :id="selectedReasonObject.id"
        @updateOtherExplanation="updateOtherExplanation"
        data-testid="cancellation-feedback-field"
      />
    </div>

    <div>
      <i18n-t keypath="subscription_cancel_footnote" tag="p" class="tw:text-sm tw:text-gray-600 tw:my-6">
        <template #EndDate>
          <SmallDotLoader v-if="!studioPlusCampaign" />
          <b v-else>{{ formatDate(studioPlusCampaign.nextPaymentDate) }}</b>
        </template>
      </i18n-t>
    </div>
  </div>
</template>
<script setup>
import { computed } from 'vue'

import BaseSelect from '@/components/BaseSelect.vue'
import HintsCard from './HintsCard.vue'
import SmallDotLoader from '@/components/base/loaders/SmallDotLoader.vue'
import FeedbackField from './FeedbackField.vue'

import { useStudioPlusCampaign } from '@/components/payment/queries'
import { useActiveOffer } from '@/components/hotelOffers/queries'
import { useCompetitors } from '@/components/rateInsights/queries'
import { useSessionValues } from '@/composables/useSessionValues'
import { useFormatting } from '@/composables/useFormatting'

const emit = defineEmits(['selectReason', 'updateOtherExplanation'])
const props = defineProps({
  reasons: Array,
  selectedReason: [String, null],
  selectedReasonObject: [Object, null],
  showHint: Boolean,
  reasonInfo: String,
  type: String,
  accommodationId: Number,
})

const currentAccommodationId = computed(() => props.accommodationId)
const { formatDate } = useFormatting()
const { selectedOrganisation } = useSessionValues()
const { studioPlusCampaign } = useStudioPlusCampaign(currentAccommodationId)
const { hasActiveOffer } = useActiveOffer(currentAccommodationId)
const { hasCompetitors } = useCompetitors(currentAccommodationId)

const selectReason = reason => emit('selectReason', reason)
const updateOtherExplanation = explanation => emit('updateOtherExplanation', explanation)
</script>
<style scoped>
label:before {
  display: inline-flex;
  border-radius: 100%;
  height: 24px;
  width: 24px;
  margin-right: 0.75rem;
  content: '';
  border: 1px solid var(--tw-color-gray-500);
}
label.selected-value:before {
  border: 8px solid var(--tw-color-blue-800);
}
.shadow {
  box-shadow: 0px 1px 3px 0px #0000001a;
}
.required :deep(span) {
  color: var(--tw-color-red-700);
}
p :deep(span) {
  color: var(--tw-color-red-800);
}
</style>
